import VideoGalleryContainer from "../../container/admin/video-gallery-master";

const VideoGallery = () => {
    return <VideoGalleryContainer />;
};

export default VideoGallery;